'use strict';

import { view } from '@/functions';

const prefix = '/affiliation-catalogs';

export default [
    {
        path: prefix,
        name: 'affiliation-catalogs',
        meta: {
            title: 'Affiliation catalog',
            scopes: ['read_affiliation_catalogs', 'write_affiliation_catalogs'],
        },
        component: () => view('affiliation-catalogs/index'),
    },
];
